import React from 'react';
import { Button, Modal, Form, Input, message } from 'antd';
import { POSITIVE_NUMBER_PATTERN } from '../constants';


const TopupModal = ({ translate, isModalOpen, setIsModalOpen, onSubmit, form }) => {
    const { getFieldDecorator } = form;

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err, values) => {
        
            if (Number(values.threshold_amount) > Number(values.projection_amount)) {
                message.error(translate('fundingLimit.threshold_amount_error'));
                return;
            }
            if (!err) {
                onSubmit(values);
                setIsModalOpen(false);
                form.resetFields();
                message.success(translate('confirmationModal.request_submitted_successfully'));
            }
        });
    };

    return (
        <Modal 
            title={translate('fundingLimit.topup_details')}
            visible={isModalOpen}
            onCancel={() => setIsModalOpen(false)}
            footer={null}
            maskClosable={false}
        >
            <Form 
                onSubmit={handleSubmit}
                layout="vertical"
            >
                <Form.Item label={translate('fundingLimit.projection_amount')}>
                    {getFieldDecorator('projection_amount', {
                        rules: [{ required: true, message: translate('fundingLimit.projection_amount_required') },
                            { pattern: POSITIVE_NUMBER_PATTERN, message: translate('fundingLimit.numbers_only') },
                            
                        ],
                    })(
                        <Input placeholder={translate('fundingLimit.projection_amount')} />
                    )}
                </Form.Item>

                <Form.Item label={translate('fundingLimit.threshold_amount')}>
                    {getFieldDecorator('threshold_amount', {
                        rules: [{ required: true, message: translate('fundingLimit.threshold_amount_required') },
                            { pattern: POSITIVE_NUMBER_PATTERN, message: translate('fundingLimit.numbers_only') },
                            
                        ],
                    })(
                        <Input placeholder={translate('fundingLimit.threshold_amount')} />
                    )}
                </Form.Item>

                <Form.Item className="modal-footer">
                    <Button onClick={() => setIsModalOpen(false)} style={{ marginRight: 8 }}>
                        {translate('confirmationModal.button_cancel')}
                    </Button>
                    <Button type="primary" htmlType="submit">
                        {translate('confirmationModal.button_confirm')}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default Form.create()(TopupModal);